import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import StarRating from "react-star-ratings";
import Calendar from "../../assets/images/calendar-icon-gray.png";
import Location from "../../assets/images/location-icon-gray.png";
import Clock from "../../assets/images/clock-icon-gray.png";

import { Button } from "../Button/Button.jsx";
import classes from "./dashboardbookingdetailcard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import {
  coachDemoImg,
  FlagIconBlack,
  LocationIconGray,
  ClockIconGray,
  CalendarIconGray,
  messageIconBlack,
  CancelIconBlack,
  ChatIconDisabled,
  FlagIconDisabled,
  CancelIconDisabled,
} from "../../constant/imagePath";
import { ReactSVG } from "react-svg";
import { Tooltip } from "../Tooltip";

export const DashboardBookingDetailCard = ({
  data,
  tagline,
  onClickbtn1,
  onClickbtn2,
  disabled,
}) => {
  return (
    <div
      className={`${[classes.DashboardBookingDetailCard].join(" ")}`}
      style={{ boxShadow: `0px 4px 27px ${Colors.neutralShadesOfNero}14` }}
    >
      <Row className="g-0">
        <Col md={12} className="d-flex">
          <div>
            <img
              src={data?.userData?.photo}
              className={`${[classes.profile].join(" ")}`}
            />
          </div>
          <div className={classes.headerLeft}>
            <h5 className={classes.mainHeading}>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName.split(" ")[0]}
              </span>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName.split(" ")[1]}
              </span>
            </h5>
            <div className={` ${[classes.userDetails].join(" ")}`}>
              <span className={classes.ratingStar}>
                <StarRating
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfDimGray}
                  rating={data?.userData.rating / 5}
                  starDimension="20px"
                  numberOfStars={1}
                />
              </span>

              <span
                className={`${[classes.rating].join(" ")}`}
                style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
              >
                {data?.userData.rating?.toFixed(1)}
              </span>
              {data?.userData?.role == "student" && (
                <a
                  className={`${[classes.reviews].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfDimGray,
                    ...Fonts.p2,
                  }}
                >
                  ({data?.userData?.reviews?.length} reviews)
                </a>
              )}
              <span
                className={`${[classes.break].join(" ")}`}
                style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
              />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
                {data?.userData?.sport}
              </span>
            </div>
          </div>
        </Col>

        <Col
          md={12}
          className={`${[classes.borderBottom].join(" ")}`}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
        {/* Lesson Details */}
        <Col md={12}>
          <div className={`${[classes.headingAndText].join(" ")}`}>
            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              Lesson details
            </h5>
            {console.log("asdds", data?.status)}
            {data?.userData?.role == "coach" &&
              ["accepted", "pending"].includes(data?.status) && (
                <span
                  className={`${[classes.sessionRemainingTimeText].join(" ")}`}
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfPinkSwan }}
                >
                  {data?.timeLeft} left
                </span>
              )}
          </div>
        </Col>
        <Col md={12}>
          <ul className={`${[classes.lessonDetails]}`}>
            <li>
              <ReactSVG src={CalendarIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.date}
              </span>
            </li>
            <li>
              <ReactSVG src={ClockIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.startTime} - {data?.endTime}
              </span>
            </li>
            <li>
              <ReactSVG src={LocationIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.location}
              </span>
            </li>
          </ul>
          {tagline && (
            <p
              className={`${[classes.lessonTagline].join(" ")}`}
              style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}
            >
              {tagline}
            </p>
          )}
        </Col>
        {data?.userData?.role == "coach" && (
          <>
            <Col
              md={12}
              className={`${[classes.borderBottom].join(" ")}`}
              style={
                tagline
                  ? {
                      borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                      marginTop: "0px",
                      marginBottom: "16px",
                    }
                  : {
                      borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }
              }
            />
            {/* Lesson Price */}

            <Col md={12}>
              <div className={`${[classes.headingAndText].join(" ")}`}>
                <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                  Earning
                </h5>
                <span
                  className={`${[classes.price].join(" ")}`}
                  style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                >
                  ${data?.price}
                </span>
              </div>
            </Col>
          </>
        )}

        <Col md={12} className={classes.btnsBox}>
          <Tooltip
            position="bottom"
            text={
              data?.status == "accepted"
                ? "message"
                : data?.status == "pending"
                ? "decline"
                : "report"
            }
            className={classes?.iconBtnTooltipContainer}
          >
            <Button
              customStyle={{
                marginRight: 8,
              }}
              size={"Large"}
              onClick={onClickbtn1}
              disabled={disabled}
              icon={
                data?.status == "accepted"
                  ? messageIconBlack
                  : data?.status == "pending"
                  ? CancelIconBlack
                  : FlagIconBlack
              }
              disabledIcon={
                data?.status == "accepted"
                  ? ChatIconDisabled
                  : data?.status == "pending"
                  ? CancelIconDisabled
                  : FlagIconDisabled
              }
            />
          </Tooltip>

          <Button
            disabled={disabled}
            label={
              data?.status == "complete"
                ? "Leave a review"
                : data?.status == "accepted"
                ? "Cancel the lesson"
                : data?.status == "pending"
                ? "Accept"
                : "Open Lesson"
            }
            primary={["complete", "pending"].includes(data?.status)}
            onClick={onClickbtn2}
            size={"Large"}
            customStyle={{
              ...Fonts.b1,
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

DashboardBookingDetailCard.propTypes = {
  tagline: PropTypes.string,
  data: PropTypes.object,
  onClickbtn1: PropTypes.func,
  onClickbtn2: PropTypes.func,
  disabled: PropTypes.bool,
};
DashboardBookingDetailCard.defaultProps = {
  tagline: "Please make sure to arrive 10 min before your lesson starts",
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      reviews: [{}, {}, {}, {}, {}, {}, {}],
      role: "coach",
    },
    price: 85,
    date: "Aug 12, 2021",
    startTime: "12:30PM",
    endTime: "2:30PM",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    status: "accepted",
    timeLeft: "24 hrs",
  },
  onClickbtn1: () => {},
  onClickbtn2: () => {},
};
